enum Period {
  DAYS = "days",
  WEEKS = "weeks",
  MONTHS = "months",
}

export default Period;
